export const PORT_CODE_HEADER = "Port Code";
export const PORT_NAME_HEADER = "Port Name";
export const COUNTRY_CODE_HEADER = "Country Code";
export const COUNTRY_NAME_HEADER = "Country Name";
export const IS_EUPORT_HEADER = "EU Port";
export const IS_UK_HEADER = "UK Port";
export const IS_TRANSHIPMENT = "EU ETS Transhipment";
export const IS_FEU_PORT = "FEU Port";
export const IS_FEU_TRANSHIPMENT = "FEU Transhipment";
export const IS_FEU_SMALL_ISLAND = "FEU Small Island";
export const IS_FEU_OMR = "FEU OMR";
export const IS_FEU_OMR_21 = "FEU OMR21";
export const IS_FEU_OMR_24 = "FEU OMR24";
export const IS_FEU_TRANSNATIONAL = "FEU PSC/PSO";
export const IS_FEU_TRANSNATIONAL_25 = "FEU PSC/PSO25";
export const IS_FEU_TRANSNATIONAL_26 = "FEU PSC/PSO26";
export const TERRITORY_HEADER = "Territory of";
export const THETIS_COUNTRY_HEADER = "Thetis Country Code";
export const EXPORT_ALL_PORTCODES = "Export Portcode(s)";
export const BREAD_CRUMB_PORT_CODES = [
	{
		label: "Annual Emission Verification",
		url: "",
		navId: "annual_emission_verification_navid",
	},
	{ label: "Port Codes", url: "", navId: "portcodes_navid" },
];
export const IS_SMALLISLAND_HEADER = "EU ETS Small Island";
export const IS_OMR__HEADER = "EU ETS OMR";
export const IS_TRANSNATIONAL_HEADER = "EU ETS PSC/PSO";
export const PORTCODE_ASSOCIATED_WITH_VESSEL_OR_VOYAGE_VALIDATION_TEXT =
	"Deleting this port code will impact associated vessels and reports. Are you sure you want to continue?";
export const PORTCODE_DELETE_CONFIRMATION_TEXT =
	"Are you sure want to delete this port code?";
export const IS_NI_PORT="NI Ports";
